export interface CreateAccountProps {
  redirect?: boolean;
  onSuccess?: (data: any) => void;
}

export interface BusinessContent {
  businessName: string;
  businessOwner: string;
  businessLogo: string;
  loading: boolean;
}

export interface NotificationState {
  title: string;
  message: string;
  color: string;
  loading?: boolean;
}

export interface ErrorState {
  email: string;
  password: string;
}

export interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
  reenteredPassword: string;
  userBusinessName?: string;
}

export const TERMS_OF_SERVICE_URL = "https://smartwiz.io/terms-of-service";
export const PRIVACY_POLICY_URL = "https://smartwiz.io/privacy-policy/";

export const DEFAULT_PRIMARY_COLOR = "#0077CC";
